import { render } from "./AddNewCustomer.vue?vue&type=template&id=2239b66d&ts=true"
import script from "./AddNewCustomer.vue?vue&type=script&lang=ts"
export * from "./AddNewCustomer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__